// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_2VZ6H","linkText":"nDVbB"};